var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SessionFrame',[_c('div',{staticClass:"flex-center"},[_c('div',{staticClass:"session-container"},[_c('h2',{staticClass:"session-title"},[_vm._v("Use Harmony Multisig")]),_c('br'),_c('div',{staticClass:"session-main"},[_c('TmBtn',{attrs:{"value":"Sign In"},nativeOn:{"click":function($event){return _vm.signIn()}}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }